import { render, staticRenderFns } from "./foodDetail.vue?vue&type=template&id=1804a550&scoped=true"
import script from "./foodDetail.vue?vue&type=script&lang=js"
export * from "./foodDetail.vue?vue&type=script&lang=js"
import style0 from "./foodDetail.vue?vue&type=style&index=0&id=1804a550&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1804a550",
  null
  
)

export default component.exports